import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 15,
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 15,
    },
    mutations: {
      retry: false,
    },
  },
});
